import { useEffect, useState } from "react";
import "./Sidebar.scss";
import "./icons.css"
import SidebarItem from "./SidebarItem";
import axios from "axios";
import {DashboardIcon,IndexIcon, OprationIcon, ReportIcon, SettingIcon} from "../../Assets/svg/index";

export default function Sidebar(props) {
  useEffect(() => {
    let HOST = localStorage.getItem("apiUrl");
    axios({
      url: `${HOST}/lx_content/`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      // balance section has  select date section or no? has  yearMonth or no?
      // I set into the local Storage and Then read storage from  FactorPrint Component
      response.data.report.map(v=> {
        if (v.id === "1") {
          localStorage.setItem('balanceHasDateSection',  v.date );
          localStorage.setItem('balanceHasyearMonthSection', v.yearMonth );
        }
      });

      setSideItems([
        {
          name: "پیشخوان",
          ref: "/Dashboard",
          
          // className: "fas fa-tachometer-alt",
          className: "sidebar-icon counter-icon",
          icon: DashboardIcon

        },
        {
          name: "عملیات",
          ref: "/Operation",
          // className: "fab fa-wpforms",
          className: "sidebar-icon opration-icon",
          subList: response.data.operation,
          icon: OprationIcon


        },
        {
          name: "فهرست",
          ref: "/List",
          // className: "far fa-clipboard-list",
          className: "sidebar-icon index-icon",
          subList: response.data.list,
          icon: IndexIcon


        },
        {
          name: "گزارش",
          ref: "/Report",
          // className: "fas fa-chart-line",
          className: "sidebar-icon report-icon",
          subList: response.data.report,
          icon: ReportIcon


        },
        {
          name: "تنظیمات",
          ref: "/Setting",
          // className: "far fa-cogs",
          className: "sidebar-icon setting-icon",
          icon: SettingIcon

        },
      ]);
    }
    );
  }, []);

  const [sideItems, setSideItems] = useState([
    {
      name: "پیشخوان",
      ref: "/Dashboard",
      className: " sidebar-icon counter-icon",
      icon: DashboardIcon

    },
    {
      name: "عملیات",
      ref: "/Operation",
      className: "sidebar-icon opration-icon",
      icon: OprationIcon

    },
    {
      name: "فهرست",
      ref: "/List",
      className: "sidebar-icon index-icon",
      icon: IndexIcon
    },
    {
      name: "گزارش",
      ref: "/Report",
      className: "sidebar-icon report-icon",
      icon:ReportIcon
    },

    {
      name: "تنظیمات",
      ref: "/Setting",
      className: "sidebar-icon setting-icon",
      icon: SettingIcon
    },
  ]);

  return (
    <div className="side-navbar">
      <ul>
        {sideItems.map((item, index) => {
          return (
            <SidebarItem
              key={index}
              title={item.name}
              className={item.className}
              subList={item.subList}
              refrence={item.ref}
              icon={item.icon}
            />
          );
        })}
      </ul>
    </div>
  );
}
